/**
 * Asynchronously loads the component for DealerLaunchSettingsComponent
 */

import { lazyLoad } from 'utils/loadable';

export const DealerLaunchSettingsComponent = lazyLoad(
  () => import('./index'),
  module => module.DealerLaunchSettingsComponent,
);
